import { createColumnHelper } from "@tanstack/react-table";
import { incomingItemsTable } from "../../interfaces/app_types";
import { getDateFromString } from "../funcs/time";
import InventoryAddDeleteButton from "../../components/inventory/InventoryEditDeleteButton";
import { fontColorBasedonBg, hexToRgba } from "../funcs/common";
import { downloadBarcode } from "../../api/inout";

const columnHelper = createColumnHelper<incomingItemsTable>();

const INOUT_MAP: Record<number, { label: string; style: string }> = {
  0: { label: "IN", style: "in" },
  1: { label: "OUT", style: "out" },
  2: { label: "RETURN", style: "return" },
  3: { label: "SCRAP", style: "scrap" },
};

export const inColumns = [
  columnHelper.accessor((row) => row?.entry_id, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.part_name, {
    header: "Part Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing, {
    id: "Drawing",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing_link, {
    id: "Link",
    enableColumnFilter: false,
    cell: (info) =>
      info.getValue() !== "" ? (
        <a href={info.getValue()} target="_blank" rel="noreferrer">
          <i className="bi bi-box-arrow-up-right"></i>
        </a>
      ) : (
        "NA"
      ),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    header: "Barcode Value",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    id: "Barcode",
    enableColumnFilter: false,
    cell: (info) =>
      info.getValue() !== "" ? (
        <button
          className="btn btn-outline-none text-primary p-0"
          onClick={async () => await downloadBarcode(info.getValue())}
        >
          <i className="bi bi-upc-scan"></i>
        </button>
      ) : (
        "NA"
      ),
  }),
  columnHelper.accessor((row) => row?.quantity, {
    id: "Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.action_date, {
    id: "Date",
    enableColumnFilter: false,
    cell: (info) => getDateFromString(info.getValue()),
  }),
  columnHelper.accessor((row) => row?.remarks, {
    id: "Remarks",
    cell: (info) => info.getValue(),
  }),
];

export const outColumns = [
  columnHelper.accessor((row) => row?.entry_id, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.part_name, {
    header: "Part Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing, {
    id: "Drawing",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing_link, {
    id: "Link",
    enableColumnFilter: false,
    cell: (info) =>
      info.getValue() !== "" ? (
        <a href={info.getValue()} target="_blank" rel="noreferrer">
          <i className="bi bi-box-arrow-up-right"></i>
        </a>
      ) : (
        "NA"
      ),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    header: "Barcode Value",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.quantity, {
    id: "Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.action_date, {
    id: "Date",
    enableColumnFilter: false,
    cell: (info) => getDateFromString(info.getValue()),
  }),
  columnHelper.accessor((row) => row?.party_name, {
    id: "Party",
    cell: (info) => (
      <div
        className="custom-color-label parties-label"
        style={
          {
            "--item-background-color": hexToRgba(
              info.row.original?.party_color,
              0.7
            ),
            "--item-color": fontColorBasedonBg(info.row.original?.party_color),
          } as React.CSSProperties
        }
      >
        {info.getValue()}
      </div>
    ),
  }),
  columnHelper.accessor((row) => row?.remarks, {
    id: "Remarks",
    cell: (info) => info.getValue(),
  }),
];

export const inoutColumns = [
  columnHelper.accessor((row) => row?.entry_id, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.part_name, {
    header: "Part Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.drawing, {
    id: "Drawing",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.quantity, {
    id: "Qty",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.barcode_value, {
    header: "Barcode Value",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.status, {
    id: "Status",
    enableColumnFilter: false,
    cell: (info) => {
      const entry = INOUT_MAP[info.getValue()] ?? {
        label: "UNKNOWN",
        style: "unknown",
      };
      return <div className={`styled-btn--${entry.style}`}>{entry.label}</div>;
    },
  }),
  columnHelper.accessor((row) => row?.action_date, {
    id: "Date",
    enableColumnFilter: false,
    cell: (info) => getDateFromString(info.getValue()),
  }),
  columnHelper.accessor((row) => row?.party_name, {
    id: "Party",
    cell: (info) => (
      <div
        className="custom-color-label parties-label"
        style={
          info.row.original?.party_color
            ? ({
                "--item-background-color": hexToRgba(
                  info.row.original?.party_color,
                  0.7
                ),
                "--item-color": fontColorBasedonBg(
                  info.row.original?.party_color
                ),
              } as React.CSSProperties)
            : {}
        }
      >
        {info.getValue()}
      </div>
    ),
  }),
  columnHelper.accessor((row) => row?.remarks, {
    id: "Remarks",
    cell: (info) => info.getValue(),
  }),
];
